export const cacheKey = 'reports'
